import { Slide } from "@jelly/lesson";
import config from "appConfig";

const principle: Slide = {
  title: "Fields of Application in Acoustics",
  layout: {
    type: "table",
    options: {
      cols: 4,
      rows: 4,
      colsSize: [1, 0, 0, 1],
      colSpan: {
        "0:1": 2,
      },
      gap: "10px",
      components: [
        [
          null,
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "text",
                options: {
                  formatter: "html",
                  scrollbars: false,
                  data: `Sound quality metrics can be used in different applications. For example, during the development process, various prototypes can be evaluated as if shown to a test panel with a single click, similarly, product
                  modifications can be simulated and the effect on customer satisfaction can be estimated from the respective metric value.
                  Additionally, sound quality criteria can be used to identify defective or faulty products during automated end of line testing.`,
                  styles: {
                    fontSize: "12px",
                    fontWeight: 600,
                    alignItems: "flex-start",
                    width: "662px",
                    textAlign: "center",
                  },
                },
              },
            },
          },
        ],
        [
          null,
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "image",
                options: {
                  src: `${config.ASSETS_URL}/02/case01/slide06-image01.svg`,
                  styles: {
                    width: "360px",
                  },
                },
              },
            },
          },
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "image",
                options: {
                  src: `${config.ASSETS_URL}/02/case01/slide06-image02.svg`,
                  styles: {
                    width: "360px",
                  },
                },
              },
            },
          },
        ],
        [
          null,
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "image",
                options: {
                  src: `${config.ASSETS_URL}/02/case01/slide06-image03.svg`,
                  styles: {
                    width: "360px",
                  },
                },
              },
            },
          },
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "image",
                options: {
                  src: `${config.ASSETS_URL}/02/case01/slide06-image04.svg`,
                  styles: {
                    width: "360px",
                  },
                },
              },
            },
          },
        ],
        [
          null,
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "image",
                options: {
                  src: `${config.ASSETS_URL}/02/case01/slide06-image05.svg`,
                  styles: {
                    width: "360px",
                  },
                },
              },
            },
          },
          {
            variant: "blockContainer",
            data: {
              block: {
                type: "image",
                options: {
                  src: `${config.ASSETS_URL}/02/case01/slide06-image06.svg`,
                  styles: {
                    width: "360px",
                  },
                },
              },
            },
          },
        ],
      ],
    },
    styles: {
      width: "1024px",
      height: "562px",
      alignSelf: "center",
    },
  },
};

export default principle;
